import React, { useEffect, useState } from "react";
import "./bottomBar.scss";
import { Link } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DirectionsBoatFilledIcon from '@mui/icons-material/DirectionsBoatFilled';

import StoreIcon from "@mui/icons-material/Store";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Logo from "../../../assets/JUNE-LOGO-3.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, reset } from "../../../features/auth/authSlice";

const BottomBar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logoutTimer, setLogoutTimer] = useState(null);

  const logoutHandler = async () => {
    clearTimeout(logoutTimer);
    try {
      await dispatch(logout()).unwrap();
      await dispatch(reset());
      navigate("/login");
    } catch (error) {
      console.error("An error occurred during logout: ", error);
    }
  };

  const startLogoutTimer = () => {
    const timer = setTimeout(() => {
      logoutHandler();
    }, 3000000); // 50 minutes (adjust the duration as needed)
    setLogoutTimer(timer);
  };

  const clearLogoutTimer = () => {
    if (logoutTimer) {
      clearTimeout(logoutTimer);
      setLogoutTimer(null);
    }
  };

  const handleVisibilityChange = () => {
    if (document.hidden) {
      startLogoutTimer();
    } else {
      clearLogoutTimer();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.outerWidth === 0 || window.outerHeight === 0) {
        logoutHandler();
      }
    };

    const handleBeforeUnload = (event) => {
      const navigationEntries = performance.getEntriesByType("navigation");
      if (navigationEntries.length > 0) {
        const navigationType = navigationEntries[0].type;
        if (navigationType === "reload") {
          return;
        }
      }
      logoutHandler();
      event.returnValue = "";
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("resize", handleResize);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      clearLogoutTimer();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div className="BottomBar">
      <div className="center">
        <ul className="dash_links">
          <Link to="/admin">
            <li>
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </li>
          </Link>
          <Link to="/admin/users">
            <li>
              <PersonOutlineIcon className="icon" />
              <span>Customers</span>
            </li>
          </Link>
          <Link to="/admin/packages">
            <li>
              <DirectionsBoatFilledIcon className="icon" />
              <span>Shipments</span>
            </li>
          </Link>

          <Link to="/admin/all-customer-packages">
            <li>
              <StoreIcon className="icon" />
              <span>Packages</span>
            </li>
          </Link>
          {/* <Link to="/admin/orders">
            <li>
              <CreditCardIcon className="icon" />
              <span>Orders</span>
            </li>
          </Link> */}
          <Link>
            <li onClick={logoutHandler}>
              <ExitToAppIcon className="icon" />
              <span>Sign Out</span>
            </li>
          </Link>
        </ul>
      </div>
    </div>
  );
};

export default BottomBar;